import Vue from 'vue';
import Vuex from 'vuex';

import account from './modules/account';
import app from './modules/app';
import audit from './modules/audit';
import callCenter from './modules/OZONE/callCenter';
import callCenterCampana from './modules/OZONE/callCenterCampana';
import campana from './modules/OZONE/campana';
import campanaTipo from './modules/OZONE/campanaTipo';
import campo from './modules/OZONE/campo';
import charlie from './modules/OZONE/charlie';
import cliente from './modules/OZONE/cliente';
import cuentaEmisora from './modules/OZONE/cuentaEmisora';
import deduplicacion from './modules/OZONE/deduplicacion';
import ean from './modules/OZONE/ean';
import email from './modules/OZONE/email';
import emailEstadoParticipacion from './modules/OZONE/emailEstadoParticipacion';
import envio from './modules/OZONE/envios';
import estadoCampana from './modules/OZONE/estadoCampana';
import estadoEnvio from './modules/OZONE/estadoEnvio';
import estadoParticipacion from './modules/OZONE/estadoParticipacion';
import exportacion from './modules/OZONE/exportacion';
import ficheroEnvio from './modules/OZONE/ficheroEnvio';
import finder from './modules/OZONE/finder';
import franqueo from './modules/OZONE/franqueo';
import grupo from './modules/OZONE/grupo';
import homeModule from './modules/OZONE/home';
import importacion from './modules/OZONE/importacion';
import marca from './modules/OZONE/marca';
import metodoEnvio from './modules/OZONE/metodoEnvio';
import motivoDevolucion from './modules/OZONE/motivoDevolucion';
import municipio from './modules/OZONE/municipio';
import participacion from './modules/OZONE/participacion';
import participacionDato from './modules/OZONE/participacionDato';
import provincia from './modules/OZONE/provincia';
import regalo from './modules/OZONE/regalo';
import reglasTicket from './modules/OZONE/reglasTicket';
import role from './modules/role';
import servicioMensajeria from './modules/OZONE/servicioMensajeria';
import session from './modules/session';
import subEstadoParticipacion from './modules/OZONE/subEstadoParticipacion';
import tenant from './modules/tenant';
import terminalBizum from './modules/OZONE/terminalBizum';
import tienda from './modules/OZONE/tienda';
import tipoFormaPagoCashback from './modules/OZONE/tipoPagoCashback';
import transferencia from './modules/OZONE/transferencia';
import user from './modules/user';
import validateImagenCampana from './modules/OZONE/validateImagenCampana';

Vue.use(Vuex);

// Importing Vuex and all the modules for the store
const store = new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        account,
        app,
        audit,
        callCenter,
        callCenterCampana,
        campana,
        campanaTipo,
        campo,
        charlie,
        cliente,
        cuentaEmisora,
        deduplicacion,
        ean,
        email,
        emailEstadoParticipacion,
        envio,
        estadoCampana,
        estadoEnvio,
        estadoParticipacion,
        exportacion,
        ficheroEnvio,
        finder,
        franqueo,
        grupo,
        homeModule,
        importacion,
        marca,
        metodoEnvio,
        motivoDevolucion,
        municipio,
        participacion,
        participacionDato,
        provincia,
        regalo,
        reglasTicket,
        role,
        servicioMensajeria,
        session,
        subEstadoParticipacion,
        tenant,
        terminalBizum,
        tienda,
        tipoFormaPagoCashback,
        transferencia,
        user,
        validateImagenCampana
    }
});

export default store;